//数组对象方法排序:
function sortByKey(array,key){
    return array.sort(function(a,b){
      var x=a[key];
      var y=b[key];
      return ((x<y)?-1:((x>y)?1:0));
   });
}
function sortMenu(Menu)
{
    return Menu.sort(function(a,b){
        var x=a.SysMenu.Sort;
        var y=b.SysMenu.Sort;
        return ((x<y)?-1:((x>y)?1:0));
     });
}
//获取年月日时分秒
function timeFormate(timeStamp) {
    let year = new Date(timeStamp).getFullYear();
    let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
    let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
    let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
    let mm =new Date(timeStamp).getMinutes() < 10? "0" + new Date(timeStamp).getMinutes(): new Date(timeStamp).getMinutes();
    let ss =new Date(timeStamp).getSeconds() < 10? "0" + new Date(timeStamp).getSeconds(): new Date(timeStamp).getSeconds();
    return year + "-" + month + "-" + date +" "+hh+":"+mm+':'+ss ;
  }
function isInArray(arr,element)
{
  var flag = true;
  for (let dd of arr) {
    if (JSON.stringify(dd) == JSON.stringify(element)) {
      flag = false;
      break;
    }
  }
  return flag;
}
export { 
    sortByKey,
    sortMenu,
    timeFormate,
    isInArray
}